const reloadOnChunkError = (error) => {
  const message = error?.toString?.() || '';
  if (error?.name === 'ChunkLoadError' || message.includes('Loading chunk')) {
    window.location.reload();
  }
  throw error;
};

export const loadExcelJS = async () => {
  const excelModule = await import('exceljs').catch(reloadOnChunkError);
  return excelModule.default || excelModule;
};

export const loadXLSX = async () => {
  const xlsxModule = await import('xlsx').catch(reloadOnChunkError);
  return xlsxModule.default || xlsxModule;
};
